/* POINTS */
export const FETCH_USER_POINTS = 'FETCH_USER_POINTS';
export const FETCH_USER_POINTS_SUCCESS = 'FETCH_USER_POINTS_SUCCESS';
export const FETCH_USER_POINTS_FAILURE = 'FETCH_USER_POINTS_FAILURE';

